/**
 * @group Client
 * @summary Client-safe exports for browser/React components.
 *
 * <blockquote>
 * Use this entry point from client components (e.g. 'use client') to avoid
 * bundling server-only code (signJoinTicket, verifyJoinTicket) that uses node:crypto.
 * </blockquote>
 *
 * @example
 * ```typescript
 * import { Telehealth } from '@shared/telehealth/client';
 * import type { TelehealthMeetingComponentProps } from '@shared/telehealth/client';
 * ```
 */

export { Telehealth } from '../src/classes';
export { TelehealthPackageBootstrap } from '../src/bootstrap';
export type { TelehealthMeetingComponentProps } from '../src/interfaces';
export type { TelehealthEnvironmentConfig } from '../src/config/interfaces/TelehealthEnvironmentConfig';
